import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  href?: string;
  scrollTo?: string;
}
export function Button({
  children,
  className = '',
  href,
  scrollTo
}: ButtonProps) {
  const baseClasses = `inline-flex items-center justify-center px-8 py-4 text-lg font-medium text-white transition-all duration-300 bg-terracotta rounded-sm hover:bg-terracotta-hover hover:shadow-lg hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-terracotta focus:ring-offset-linen cursor-pointer no-underline ${className}`;
  if (href) {
    return <a href={href} rel="noopener noreferrer" className={baseClasses} data-id="element-13">
        {children}
      </a>;
  }
  const handleClick = () => {
    if (scrollTo) {
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={baseClasses} data-id="element-14">
      {children}
    </button>;
}